export default __webpack_public_path__ + "static/media/plain-sticker-z.2b4b2f02.png";